import React from 'react'
import './CheckoutCard.css'
function CheckoutCard(props) {
    return (
        <div className="cardHolder">
            <div className="checkoutCardCnt d-flex">
                <img src="./images/product.png" />
                <div className="checkoutCntWrp">
                    <div className="checkoutTitle">
                        <p className="checkoutPdtTitle">Title</p>
                        <p className="checkoutPdtName">{props.Name}</p>
                    </div>
                    <div className="checkoutPrice">
                        <p className="priceTitle">Price</p>
                        <p className="checkoutPdtPrice">{props.Price}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CheckoutCard
